import React, {useRef} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const MiddleYoungLanding = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const colors = useDynamicColors();
  const scrollRef = useRef(null);

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/sport-card_details-MIDDLEYOUNG-mobile${currentParams}`);
  };

  const veritranLogo = "https://vxapp-components.wfsystems.com.ar/veritran.png";
  const realMadridLogo = "https://upload.wikimedia.org/wikipedia/en/thumb/5/56/Real_Madrid_CF.svg/1200px-Real_Madrid_CF.svg.png";
  const avatarUrl = "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face";

  const quickCards = [
    { title: "Success!", icon: veritranLogo },
    { title: "New Branding", icon: veritranLogo },
    { title: "About Us", icon: veritranLogo },
    { title: "Expansion", icon: veritranLogo },
  ];

  return (
    <div className="contenedor">
      <div className="middleyoung-landing" ref={scrollRef}>
        <div className="my-div-3">
          {/* Header */}
          <header className="my-header">
            <div className="my-header-content">
              <div className="my-menu-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect y="4" width="24" height="2" fill="white"/>
                  <rect y="11" width="24" height="2" fill="white"/>
                  <rect y="18" width="24" height="2" fill="white"/>
                </svg>
              </div>
              <img className="my-club-logo" src={colors.url_logo} alt="Club Logo" />
              <div className="my-bell-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
          </header>

          <div className="my-content">
            {/* User Profile Card */}
            <div className="my-profile-card">
              <div className="my-avatar-container">
                <img className="my-avatar" src={avatarUrl} alt="User Avatar" />
              </div>
              <div className="my-profile-info">
                <h2 className="my-user-name">Santiago</h2>
                <p className="my-member-since">Member since 2025</p>
                <div className="my-points-badge">
                  <span>200 pts</span>
                </div>
              </div>
            </div>

            {/* Quick Action Cards */}
            <div className="my-quick-cards">
              {quickCards.map((card, index) => (
                <div className="my-quick-card" key={index}>
                  <div className="my-quick-card-icon" style={{ borderColor: colors.primario }}>
                    <img src={card.icon} alt={card.title} />
                  </div>
                  <span className="my-quick-card-title">{card.title}</span>
                </div>
              ))}
            </div>

            {/* Tabs */}
            <div className="my-tabs">
              <div className="my-tab my-tab-active" style={{ borderColor: colors.primario }}>
                Buy Tickets
              </div>
              <div className="my-tab">
                My tickets
              </div>
            </div>

            {/* Search Bar */}
            <div className="my-search-bar">
              <svg className="my-search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle cx="11" cy="11" r="8" stroke="#999" strokeWidth="2"/>
                <path d="M21 21L16.65 16.65" stroke="#999" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              <input type="text" placeholder="Search match" className="my-search-input" />
            </div>

            {/* Next Matches Section */}
            <div className="my-matches-section">
              <h3 className="my-section-title">Next matches</h3>

              {/* Match Card */}
              <div className="my-match-card" style={{ background: `linear-gradient(135deg, ${colors.secundario} 0%, ${colors.primario} 100%)` }}>
                <div className="my-match-header">
                  <div className="my-match-info">
                    <div className="my-match-location">Local Stadium - North Gate</div>
                    <div className="my-match-date">TUE 24 FEBRUARY   15:00</div>
                  </div>
                  <div className="my-countdown-side">
                    <div className="my-countdown-item">
                      <span className="my-countdown-number">43</span>
                      <span className="my-countdown-label">DAYS</span>
                    </div>
                    <div className="my-countdown-item">
                      <span className="my-countdown-number">3</span>
                      <span className="my-countdown-label">HRS</span>
                    </div>
                    <div className="my-countdown-item">
                      <span className="my-countdown-number">4</span>
                      <span className="my-countdown-label">MIN</span>
                    </div>
                  </div>
                </div>

                <div className="my-match-teams">
                  <div className="my-team">
                    <img src={colors.url_logo} alt="Team 1" className="my-team-logo" />
                  </div>
                  <div className="my-team">
                    <img src={realMadridLogo} alt="Real Madrid" className="my-team-logo" />
                  </div>
                </div>

                <button
                  className="my-buy-button"
                  style={{ backgroundColor: colors.primario }}
                  onClick={handleButtonClick}
                >
                  Buy Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
